import cn from 'classnames';
import React from 'react';
import styles from './container.module.css';

type PropsType = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

/** Centers content */
const Container: React.FC<PropsType> = ({ className, children, ...others }) => {
  return (
    // our-container class check if div element exists in first child. if not no class is applied.
    // useful when we have no clue if children renders anything (e.g ContentCmsHeaderContentStatic)
    (<div className={cn(styles['our-container'], className)} {...others}>
      {children}
    </div>)
  );
};

export default Container;
